module.exports = __webpack_public_path__ + "static/media/cases_ident_visual_fiat_02.da39fedd.jpg";